import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import CelebrationIcon from "@mui/icons-material/Celebration";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { useAppConfig } from "../../context/AppConfigContext";
import { useNavigate } from "react-router-dom";

const iconMap = {
  CelebrationIcon: <CelebrationIcon fontSize="large" />,
  EmojiEmotionsIcon: <EmojiEmotionsIcon fontSize="large" />,
  LocalFireDepartmentIcon: <LocalFireDepartmentIcon fontSize="large" />,
  CardGiftcardIcon: <CardGiftcardIcon fontSize="large" />,
};

const EmotionBrowser = () => {
  const { config } = useAppConfig();
  const navigate = useNavigate();
  const moods = config?.landingPage?.emotionBrowser || [];

  return (
    <Box sx={{ py: 10, px: 2 }}>
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign="center"
        gutterBottom>
        Browse By Feeling
      </Typography>
      <Typography
        variant="body1"
        textAlign="center"
        sx={{ mb: 6, maxWidth: 600, mx: "auto" }}>
        Tell us how you're feeling. We’ll match you with something sweet.
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {moods.map((mood, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Paper
              elevation={2}
              onClick={() => navigate(mood.url)}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                cursor: "pointer",
                "&:hover": { boxShadow: 6, backgroundColor: "#FFF5F3" },
              }}>
              <Box sx={{ mb: 2 }}>{iconMap[mood.icon]}</Box>
              <Typography variant="h6" fontWeight="bold">
                {mood.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "text.secondary", mt: 1 }}>
                → {mood.suggestion}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EmotionBrowser;
